import React from 'react'
import { ConfigConsumer } from 'contexts/config-context'
import PropTypes from 'prop-types'
import Link from '../Link'

function OnSiteLink (props) {
  const { href, children, onClick, ...remainingProps } = props
  return (
    <ConfigConsumer>
      {config => (
        <Link
          {...remainingProps}
          onClick={
            config.onLinkClick
              ? (event) => {
                onClick && onClick(event)
                config.onLinkClick(event, href)
              }
              : null}
          href={href}
        >
          {children}
        </Link>
      )}
    </ConfigConsumer>
  )
}
OnSiteLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
}

export default OnSiteLink



// WEBPACK FOOTER //
// ./src/atoms/OnSiteLink/OnSiteLink.js